// extracted by mini-css-extract-plugin
export default {"button":"HeaderCartBut_button__8Qy0l","icon":"HeaderCartBut_icon__ZS83A","badge":"HeaderCartBut_badge__AnejI","bump":"HeaderCartBut_bump__QrqRr"};